// A worker with a lapsed mandatory check can still be rostered when an administrator decides to,
// but only on purpose. The server refuses with COMPLIANCE_LAPSED (when the org has turned the block
// on), we ask, and the retry carries overrideCompliance so the decision is written to the shift's
// history. `send(extra)` performs the request with `extra` merged into its body.
//
// Throws what the request threw, except when the admin chooses not to roster: then it throws an
// error with `cancelled: true`, which callers treat as "nothing happened" rather than a failure.
export async function withComplianceOverride(confirm, send) {
  try {
    return await send({});
  } catch (err) {
    const d = err?.response?.data;
    if (err?.response?.status !== 409 || d?.code !== 'COMPLIANCE_LAPSED') throw err;
    const ok = await confirm(
      `${d.message}\n\nRoster them anyway? This is recorded in the shift history.`,
      { title: 'Mandatory check lapsed', danger: true, confirmLabel: 'Roster anyway', cancelLabel: 'Pick someone else' },
    );
    if (!ok) {
      const e = new Error('Not rostered');
      e.cancelled = true;
      throw e;
    }
    return send({ overrideCompliance: true, overrideReason: 'Confirmed in the scheduler' });
  }
}
